import { IPlaceAddress } from '@fhs-legacy/frontend/src/utils/geolocation';
import { ILocation } from '@rbi-ctg/frontend';

import type { AddressSearchInputHandle } from '../search-field/types';

/** An address the guest picked from the delivery typeahead, resolved to its place details. */
export interface DeliveryAddressSelection {
  /** Full prediction text, as shown in the field. */
  description: string;
  /** First line of the prediction, e.g. "1300 Hendricks Avenue". */
  mainText: string;
  /** Rest of the prediction, e.g. "Jacksonville, FL, USA". */
  secondaryText: string;
  placeId: string;
  address: IPlaceAddress;
  coordinates: ILocation;
}

export enum DeliveryValidationStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  UNAVAILABLE = 'unavailable',
}

export interface DeliveryPanelProps {
  selection: DeliveryAddressSelection | null;
  onSelectionChange: (next: DeliveryAddressSelection | null) => void;
  onSwitchToPickup: () => void;
}

export type DeliveryAddressFieldHandle = AddressSearchInputHandle;

export interface DeliveryAddressFieldProps {
  value: DeliveryAddressSelection | null;
  onChange: (next: DeliveryAddressSelection | null) => void;
  disabled?: boolean;
}

export interface NoDeliveryRestaurantsModalProps {
  isVisible: boolean;
  address: DeliveryAddressSelection | null;
  onSwitchToPickup: () => void;
  onChangeAddress: () => void;
  onClose: () => void;
}

export interface SavedAddressesSectionProps {
  isAuthenticated: boolean;
}
